<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Atendimento domiciliar - Inconsistências"
    >
        <template v-if="data">

            <Inconsistencia
                v-if="inconsistenciaVersao"
                :inconsistencias="inconsistenciaVersao"
            />

            <rkm-area
                title="Profissional responsável"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissionalResponsavel.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissionalResponsavel.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissionalResponsavel.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissionalResponsavel.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="INE"
                            :value="data.profissionalResponsavel.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissionalResponsavel.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data"
                            :value="data.profissionalResponsavel.campos.dataAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissionalResponsavel.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Profissional auxiliar"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissionalAuxiliar.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNS"
                            :value="data.profissionalAuxiliar.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNES"
                            :value="data.profissionalAuxiliar.campos.cnes"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="INE"
                            :value="data.profissionalAuxiliar.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissionalAuxiliar.campos.cboCodigo2002"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissionalAuxiliar.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Pacientes"
                type="fieldset"
            >
            <Inconsistencia :inconsistencias="data.atendimentos.inconsistencias" />
                <rkm-list
                    hide-pagination
                    hide-filters
                    :items="atendimentosComInconsistencia"
                    class="p-0"
                >
                    <template v-slot="{ item }">
                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Paciente:</strong> {{ item.paciente.campos.nomeCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>CNS:</strong> {{ item.paciente.campos.cnsCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Data de nascimento:</strong> {{ item.paciente.campos.dataNascimento }}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{ item }">
                        <div class="p-3">
                            <rkm-area
                                title="Paciente"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            label="CNS"
                                            :value="item.paciente.campos.cnsCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="CPF"
                                            :value="item.paciente.campos.cpfCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Data de nascimento"
                                            :value="item.paciente.campos.dataNascimento"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Sexo"
                                            :value="item.paciente.campos.sexo"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            label="Local de atendimento"
                                            :value="item.paciente.campos.localAtendimento"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Tipo de atendimento"
                                            :value="item.paciente.campos.tipoAtendimento"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Modalidade"
                                            :value="item.paciente.campos.atencaoDomiciliarModalidade"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Turno"
                                            :value="item.paciente.campos.turno"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.paciente.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Condições avaliadas"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.condicoesAvaliadas.lista.map(value => ({ value }))"
                                    :fields="[{ key: 'value', label: 'Condição avaliada' }]"
                                />

                                <Inconsistencia :inconsistencias="item.condicoesAvaliadas.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Problemas e/ou condições avaliados"
                                type="fieldset"
                            >
                                <rkm-list
                                    hide-pagination
                                    hide-filters
                                    :items="item.problemasCondicoes.lista"
                                    class="p-0"
                                    item-cursor="default"
                                >
                                    <template v-slot="{ item }">
                                        <rkm-row>
                                            <rkm-col cols="5">
                                                <strong>CIAP:</strong> {{ item.campos.ciap }}
                                            </rkm-col>

                                            <rkm-col cols="5">
                                                <strong>CID:</strong> {{ item.campos.cid10 }}
                                            </rkm-col>

                                            <rkm-col>
                                                <strong>Avaliado:</strong> {{ item.campos.isAvaliado }}
                                            </rkm-col>
                                        </rkm-row>

                                        <Inconsistencia :inconsistencias="item.inconsistencias" />
                                    </template>
                                </rkm-list>

                                <Inconsistencia :inconsistencias="item.problemasCondicoes.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="IVCF - Índice de vulnerabilidade clínico-funcional"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.resultado"
                                            label="Resultado"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgIdade"
                                            label="Idade"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgPercepcaoSaude"
                                            label="Percepção de saúde"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAvdInstrumental"
                                            label="Atividades instrumentais da vida diária"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAvdBasica"
                                            label="Atividades básicas da vida diária"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgCognicao"
                                            label="Cognição"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgHumor"
                                            label="Humor"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAlcancePreensaoPinca"
                                            label="Alcance preensão pinça"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgCapAerobicaMuscular"
                                            label="Capacidade aeróbica muscular"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgMarcha"
                                            label="Marcha"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgContinencia"
                                            label="Continência"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgVisao"
                                            label="Visão"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAudicao"
                                            label="Audição"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgComorbidade"
                                            label="Comorbidade"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.dataResultado"
                                            label="Data do resultado"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.ivcf.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Procedimentos"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.procedimentos.lista.map(value => ({ value }))"
                                    :fields="[{ key: 'value', label: 'Procedimento' }]"
                                />

                                <Inconsistencia :inconsistencias="item.procedimentos.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Outros"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            label="Conduta/Desfecho"
                                            :value="item.outro.campos.condutaDesfecho"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.outro.inconsistencias" />
                            </rkm-area>
                        </div>
                    </template>
                </rkm-list>

            </rkm-area>
        </template>


        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        inconsistenciaVersao(){
            const texto = this.inconsistencia?.inconsistencia || ''
      

            const versaoErro = this.extrairVersaoDescricao(texto)
            const versao = this.extrairVersao(texto)

            if(!versaoErro) return []

            return [
                `A versão atual do LEDI (${versao}) não é compatível com a versão do seu integrador.`        
            ]
        
        },  
        atendimentosComInconsistencia(){
            return this.data.atendimentos.lista.map(item => ({
                ...item, 
                _listItemColor: this.isInconsistencia(item) ? 'danger': ''
            }))
        },
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => {
                    this.data = data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        isInconsistencia(item){

            const blocos = [
                item.condicoesAvaliadas,
                item.ivcf,
                item.outro,
                item.paciente,
                item.problemasCondicoes,
                item.procedimentos
            ]
         
            return blocos.some(b =>{
                if (!b) return false

                if(Array.isArray(b.lista)){
                    return b.lista.some(item =>
                        Array.isArray(item.inconsistencias) && item.inconsistencias.lenght > 0
                    )
                }

                return false
            })
        },
        extrairVersaoDescricao(texto) {

            if (!texto) return null

            texto = texto.replace(/\\u00e3/g, 'ã')

            const match = texto.match(/vers[aã]o\s+([\d.]+)\s+inexistente/i)

            return match ? match[1] : null
        },

        extrairVersao(texto){
            if (!texto) return null

            const match = texto.match(/\d+\.\d+\.\d+/)

            return match ? match[0] : null
        }
    },
    mixins: [repository, error]
}
</script>